import React from 'react'
import "./Footer.css"

function index() {
    return (
        <div className="footer">
            <p>Made by @JavohirK. 2021</p>
        </div>
    )
}

export default index
